import store from '@Store';
import keyBy from 'lodash/keyBy';
import { rcsResultsStoreProductsType, rcsResultsSetAllCheckedProductsForSubstanceType } from './RcsResultsReducer';
import { rcsResultsProducts } from './RcsResultsSelectors';

export function storeProducts({ substanceId, products }) {
  return {
    type: rcsResultsStoreProductsType,
    payload: {
      substanceId,
      products,
    },
  };
}

export function setCheckedAllProductsForSubstance({ substanceId, checked }) {
  return {
    type: rcsResultsSetAllCheckedProductsForSubstanceType,
    payload: {
      substanceId,
      checked,
    },
  };
}

export function getProductsFromStore() {
  return (dispatch, getState) => {
    return rcsResultsProducts(getState()).toJS();
  };
}

// API outside of Redux
export function dispatchStoreProducts({ substanceId, data }) {
  const products = keyBy(data, 'rcSubstanceId');
  return store.dispatch(
    storeProducts({
      substanceId,
      products,
    })
  );
}

export function dispatchSetCheckedAllProductsForSubstance(...args) {
  return store.dispatch(setCheckedAllProductsForSubstance(...args));
}

// Get everything, for BE
export function dispatchGetProductsFromStore() {
  return store.dispatch(getProductsFromStore());
}
